import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import Buttonlet from 'components/Buttonlet';
import Contacts from 'components/Contacts';
import MediaMdDown from 'components/Responsive/MediaMdDown';
import { IAppState } from 'types/app';

import GoBackButton from './GoBackButton';
import MessagePreferences from './MessagePreferences';
import MetaQualities from './MetaQualities';
import MessageMethod from './MessageMethod';
import MapSettings from './MapSettings';
import AuthMethods from './AuthMethods';
import Subscriptions from './Subscriptions';

type OwnProps = {
  hash?: string,
  message?: string | undefined,
  onLogout: () => void,
  onSummonChangeUsernameModal: () => void,
  onSummonDeactivateAccountModal: () => void,
  onSummonPasswordResetRequestModal: () => void,
};

export function Account(props: Props) {
  const {
    hash,
    loggedIn,
    message,
    onLogout,
    onSummonChangeUsernameModal,
    onSummonDeactivateAccountModal,
    onSummonPasswordResetRequestModal,
    data: { name },
  } = props;

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  });

  return (
    <div className="content container">
      <div className="account" style={{ margin: 10 }}>
        <h1 className="heading heading--1" style={{ marginTop: 5 }}>
          <GoBackButton />
          Account settings
        </h1>

        <MediaMdDown>
          <hr />
        </MediaMdDown>

        <ReactCSSTransitionReplace transitionName="fade-wait" transitionEnterTimeout={100} transitionLeaveTimeout={100}>
          {message ? (
            <div key="message" style={{ paddingBottom: 24 }}>
              <p style={{ padding: 12, background: '#3f7277', color: '#fff' }}>
                {message}
              </p>
            </div>
          ) : <p key="none" />}
        </ReactCSSTransitionReplace>

        <div className="account__body">
          <div className="account__left">
            <div>
              <div>
                <h2 className="heading heading--2">User profile</h2>
                <p>
                  Username:
                  {' '}
                  {name}
                  {' '}
                  (
                  <button
                    className="button--link"
                    onClick={onSummonChangeUsernameModal}
                    type="button"
                  >
                    edit
                  </button>
                  )
                </p>
                <ul className="list--padded">
                  <li>
                    <button
                      className="button button--primary"
                      onClick={onLogout}
                      type="button"
                    >
                      Log out
                    </button>
                  </li>
                  <li>
                    <button
                      className="button button--primary"
                      onClick={onSummonPasswordResetRequestModal}
                      type="button"
                    >
                      Reset password
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="button button--dangerous"
                      onClick={onSummonDeactivateAccountModal}
                    >
                      Deactivate Account
                    </button>
                    <Buttonlet
                      type="question"
                      // eslint-disable-next-line max-len
                      title="This will permanently remove your user account and all characters IN ALL STORYNEXUS WORLDS attached to it. Please note: deactivation does not cancel mobile Exceptional Friendship. To do that, please access your device's Google/Apple account settings."
                    />
                  </li>
                </ul>
              </div>
              <hr />
              <AuthMethods />
            </div>
            <hr />

            <div>
              <MessagePreferences />
              <hr />
              <MessageMethod />
            </div>
            <hr />
            <MetaQualities />
            <hr />
            <MapSettings />
          </div>
          <div className="account__right">
            <MediaMdDown>
              <hr />
            </MediaMdDown>
            <Subscriptions />
            <hr />
            <h2 className="heading heading--2">Blocked Users</h2>
            <p>
              Receiving abusive messages via StoryNexus? Report the troublemaker at
              {' '}
              <a href="mailto:abuse@storynexus.com">abuse@storynexus.com</a>
              .
            </p>
            <hr />
            {loggedIn && <Contacts />}
          </div>
        </div>
      </div>
    </div>
  );
}

Account.displayName = 'Account';

const mapStateToProps = ({
  user: { loggedIn },
  settings: { data },
}: IAppState) => ({
  data,
  loggedIn,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps)(Account);